import {request,newVue,requestMsg} from "./request";
export {newVue}

export function getUserCouponsBySearch(couponsId,state,couponsName,userId,pageNum,pageSize) {
  return request({
    url: '/userCoupons/getUserCouponsList',
    params: {
      couponsId:couponsId,
      state:state,
      couponsName:couponsName,
      userId:userId,
      pageNum: pageNum,
      pageSize: pageSize
    }
  })
}

export function getUserCouponsById(id) {
  return request({
    url: '/userCoupons/getUserCouponsById',
    params: {
      id:id
    }
  })
}
